export default {
    'diagram10-3a1': {
        'diagram-number': '10.',
        'elements': {
            'one': 'Plant microbiologists see evidence that plants sense and respond to environmental variables',
            'two': 'Suspect they have a sophisticated, brain-like information processing and signalling system to sense and respond',
            'three': 'But without an actual brain, think their intelligence may be organized In a network, like insect colonies',
            'four': 'Thus they are researching how networks can inspire brainy behaviour in the absence of actual brains',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram10/i18n/en.js